import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.pages.slack`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Slack integration',
  },
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  integrationsTitle: {
    id: `${scope}.integrationsTitle`,
    defaultMessage: 'Integrations',
  },
})
